export const TYPE_IMAGES = {
  idler: "/components/idler.webp",
  "track-roller": "/components/track-roller.webp",
  "carrier-roller": "/components/track-roller.webp",
  sprocket: "/components/sprocket.webp",
  "track-group": "/components/track-group.webp",
  "track-shoe": "/components/track-shoe.webp",
  "track-chain": "/components/track-chain.webp",
  "rubber-track": "/components/rubber-track.webp",
  "track-bolt-nut": "/components/track-bolt-nut.webp",
  "rubber-pad": "/components/rubber-pad.webp",
};

export const TYPE_IMAGES_CUT = {
  idler: "/components/cut/idler.webp",
  "track-roller": "/components/cut/track-roller.webp",
  "carrier-roller": "/components/cut/track-roller.webp",
  sprocket: "/components/cut/sprocket.webp",
  "track-group": "/components/cut/track-group.webp",
  "track-shoe": "/components/cut/track-shoe.webp",
  "track-chain": "/components/cut/track-chain.webp",
  "rubber-track": "/components/cut/rubber-track.webp",
  "track-bolt-nut": "/components/cut/track-bolt-nut.webp",
  "rubber-pad": "/components/cut/rubber-pad.webp",
};

export const TYPE_IMAGES_SECONDARY = {
  sprocket: { src: "/components/sprocket-segment.webp", label: "Segments" },
};
